<div
  class="add-btn"
  id="tour-custom-add-record"
  [class.compact]="variant === 'compact'"
>
  <a
    href="javascript:void(0);"
    (click)="!disableAddBusinessButton && (showAddBusinessPopup = true)"
    [class.disabled]="disableAddBusinessButton"
  >
    <app-svg-icon
      [iconName]="'add.svg'"
      [height]="'16px'"
      [width]="'16px'"
      [style.fill]="'#fff'"
    ></app-svg-icon>
    <span>{{ buttonLabel }}</span>
  </a>
</div>

@if (showAddBusinessPopup) {
  <app-secondary-popup
    [title]="'Add Custom Business'"
    [primaryActionName]="'Next'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitBusinessDetailForm()"
    (secondaryAction)="closeAllPopups($event)"
  >
    <app-business-detail-form
      #businessDetailForm
      [initialValue]="businessDetails"
      (formSubmit)="onBusinessFormSubmit($event)"
    >
    </app-business-detail-form>
  </app-secondary-popup>
}

@if (showLoanForm) {
  <app-secondary-popup
    [title]="getCurrentFormTitle()"
    [primaryActionName]="'Next'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitLoanForm()"
    (secondaryAction)="onBack()"
  >
    <app-business-loan-form
      #businessLoanForm
      [initialValue]="loanDetails"
      [creditScoreRange]="loanDetails?.creditScoreRange"
      (formSubmit)="onLoanFormSubmit($event)"
    >
    </app-business-loan-form>
  </app-secondary-popup>
}

@if (showTechnicalAssistanceForm) {
  <app-secondary-popup
    [title]="getCurrentFormTitle()"
    [primaryActionName]="'Next'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitTechnicalAssistanceForm()"
    (secondaryAction)="onBack()"
  >
    <app-technical-assistance-form
      #technicalAssistanceForm
      [initialValue]="technicalAssistanceDetails"
      (formSubmit)="onTechnicalAssistanceFormSubmit($event)"
    >
    </app-technical-assistance-form>
  </app-secondary-popup>
}

@if (showOperationalToolsForm) {
  <app-secondary-popup
    [title]="getCurrentFormTitle()"
    [primaryActionName]="'Next'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitOperationalToolsForm()"
    (secondaryAction)="onBack()"
  >
    <app-operational-tools-form
      #operationalToolsForm
      [initialValue]="operationalToolsDetails"
      (formSubmit)="onOperationalToolsFormSubmit($event)"
    >
    </app-operational-tools-form>
  </app-secondary-popup>
}

@if (showRealEstateForm) {
  <app-secondary-popup
    [title]="getCurrentFormTitle()"
    [primaryActionName]="'Next'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitRealEstateForm()"
    (secondaryAction)="onBack()"
  >
    <app-real-estate-form
      #realEstateForm
      [initialValue]="realEstateDetails"
      [solarAlreadySelected]="isSolarAlreadySelected()"
      (formSubmit)="onRealEstateFormSubmit($event)"
      (energyUpgradesChange)="onEnergyUpgradesChange($event)"
    >
    </app-real-estate-form>
  </app-secondary-popup>
}

@if (showSolarEnergyForm) {
  <app-secondary-popup
    [title]="getCurrentFormTitle()"
    [primaryActionName]="'Next'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitSolarEnergyForm()"
    (secondaryAction)="onBack()"
  >
    <app-solar-energy-form
      #solarEnergyForm
      [initialValue]="solarEnergyDetails"
      [creditScoreRange]="
        loanDetails?.creditScoreRange || solarEnergyDetails?.creditScoreRange
      "
      (formSubmit)="onSolarEnergyFormSubmit($event)"
    >
    </app-solar-energy-form>
  </app-secondary-popup>
}

@if (showFindingInvestorsForm) {
  <app-secondary-popup
    [title]="getCurrentFormTitle()"
    [primaryActionName]="'Next'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitFindingInvestorsForm()"
    (secondaryAction)="onBack()"
  >
    <app-finding-investors-form
      #findingInvestorsForm
      [initialValue]="findingInvestorsDetails"
      (formSubmit)="onFindingInvestorsFormSubmit($event)"
    >
    </app-finding-investors-form>
  </app-secondary-popup>
}

@if (showLeadAttributes) {
  <app-secondary-popup
    [title]="'Add Custom Business'"
    [secondaryActionName]="'Back'"
    (popupClosed)="closeAllPopups($event)"
    (primaryAction)="submitAttributesForm()"
    (secondaryAction)="onBack()"
  >
    <app-business-attributes-form
      #businessAttributesForm
      [businessDetails]="businessDetails"
      [loanDetails]="loanDetails"
      [technicalAssistanceDetails]="technicalAssistanceDetails"
      [operationalToolsDetails]="operationalToolsDetails"
      [realEstateDetails]="realEstateDetails"
      [solarEnergyDetails]="solarEnergyDetails"
      [findingInvestorsDetails]="findingInvestorsDetails"
      [initialValue]="attributeDetails"
      (formSubmit)="onAttributesFormSubmit($event)"
    >
    </app-business-attributes-form>
  </app-secondary-popup>
}
